import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-card-table-simple',
  standalone: true,
  imports: [],
  template: `
    <div class="white_card card_height_100">
      <div class="white_card_header">
        <div class="row align-items-center justify-content-between">
          <!-- HEADER TITLE -->
          <div class="col-auto d-none d-md-flex">
            <ng-content select="[card-title]"></ng-content>
          </div>
          <!-- SEARCH COMPONENT -->
          <div class="col text-end">
            <ng-content select="[card-search-action]"></ng-content>
          </div>
          <!-- BUTTONS -->
          <div class="col-auto d-none d-md-flex text-end">
            <ng-content select="[card-actions]"></ng-content>
          </div>
          <!-- ADD BTN SMALL DEVICE-->
          <div class="col-auto d-flex d-md-none text-end">
            <ng-content select="[card-sm-actions]"></ng-content>
          </div>
        </div>
      </div>
      <div class="white_card_content">
        <ng-content select="[card-content]"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./card-table-simple.component.css'],
})
export class CardTableSimpleComponent {}
